import { FiltersV2AutoRefreshToggle, useFiltersV2Actions } from "PFApp/components/filters_v2";
import { FiltersV2ResetAllButton } from "PFApp/components/filters_v2/components/filters_v2_reset_all_button";
import { useFiltersBufferState } from "PFApp/components/filters_v2/hooks/use_filters_buffer_state";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "../filters_v2_panel.module.scss";

type FiltersV2PanelHeaderProps = {
  lastFocusedFilterNameRef?: React.MutableRefObject<string | null>;
};

export const FiltersV2PanelHeader = ({ lastFocusedFilterNameRef }: FiltersV2PanelHeaderProps) => {
  const { t } = useTranslation("filters", { keyPrefix: "panel" });

  const { resetBufferValues } = useFiltersV2Actions();
  const { areFiltersDefaultOrEmpty } = useFiltersBufferState();

  return (
    <Inline alignItems="center" className={css.header}>
      <Inline alignItems="baseline">
        <Typography variant="h4">{t("title")}</Typography>
      </Inline>
      {!areFiltersDefaultOrEmpty && (
        <FiltersV2ResetAllButton
          onReset={() => {
            if (lastFocusedFilterNameRef?.current) {
              lastFocusedFilterNameRef.current = null;
            }
            resetBufferValues();
          }}
        />
      )}
      <FiltersV2AutoRefreshToggle />
    </Inline>
  );
};
